import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const GoToTop = () => {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(false);
    const [pulse, setPulse] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onClick = () => {
        setPulse(true);
        window.scrollTo({ top: 0, left: 0 });
        setTimeout(() => setPulse(false), 450);
    };

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={t.backToTop}
            data-testid="back-to-top"
            className={`fixed bottom-[4.5rem] end-4 z-40 hidden h-12 w-12 items-center justify-center rounded-full bg-pine text-cream shadow-[0_14px_30px_-12px_rgba(0,77,77,0.6)] transition-[opacity,transform] duration-300 hover:bg-pine-600 md:bottom-8 md:end-8 md:flex ${
                pulse ? "scale-90" : ""
            } ${visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
        >
            <ArrowUp
                className={`h-5 w-5 transition-transform duration-300 ${pulse ? "-translate-y-1 scale-125" : ""}`}
                strokeWidth={2}
                aria-hidden="true"
            />
        </button>
    );
};

export default GoToTop;
